<app-header [showUserInfo]="false"></app-header>

<div style="margin: 12px 24px">
  <p>Initializing...</p>
</div>
